import { render, staticRenderFns } from "./TreeMenus.vue?vue&type=template&id=6ad485fe&scoped=true"
import script from "./TreeMenus.vue?vue&type=script&lang=js"
export * from "./TreeMenus.vue?vue&type=script&lang=js"
import style0 from "./TreeMenus.vue?vue&type=style&index=0&id=6ad485fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad485fe",
  null
  
)

export default component.exports